import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import videoclassRouter from '../router/videoclass/videoclassRouter';
import serveRouter from '../router/serve';
import activityRouter from '../router/activity';
import expertRouter from '../router/expert';
import projectRouter from '../router/project';
import policyRouter from '../router/policy';



export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/page/home'),
    },
    {
      path: '/policy',
      name: 'policy',
      component: () => import('@/page/policy/policy'),
    },
    {
      path: '/learn',
      name: 'learn',
      component: () => import('@/page/learn/learn'),
    },
    {
      path: '/serve',
      name: 'serve',
      component: () => import('@/page/serve/serve'),
    },
    {
      path: '/activity',
      name: 'activity',
      component: () => import('@/page/activity/activity'),
    },
    {
      path: '/expert',
      name: 'expert',
      component: () => import('@/page/expert/expert'),
    },
    {
      path: '/project',
      name: 'project',
      component: () => import('@/page/project/project'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/page/login/login'),
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/page/login/register'),
    },
    {
      path: '/forgetpwd',
      name: 'forgetpwd',
      component: () => import('@/page/login/forgetpwd'),
    },
    {
      path: '/completeinfor',
      name: 'completeinfor',
      component: () => import('@/page/login/completeinfor'),
    },
    {
      path: '/me',
      name: 'me',
      component: () => import('@/page/me/me'),
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: () => import('@/page/about/aboutus'),
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: () => import('@/page/about/feedback'),
    },
    {
      path: '/pay',
      name: 'pay',
      component: () => import('@/page/pay/pay'),
    },
    {
      path: '/addEnroll',
      name: 'addEnroll',
      component: () => import('@/page/addEnroll'),
    },
    {
      path: '/readAgreement',
      name: 'readAgreement',
      component: () => import('@/page/login/readAgreement'),
    },

  ].concat(videoclassRouter,serveRouter,activityRouter,expertRouter,projectRouter,policyRouter,)
})
